import { AddAccountWebController } from '../controller/AddAccountWebController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class AddAccountWebComponent extends BaseWebComponentElement {
  public controller!: AddAccountWebController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AddAccountWebController,
    });
  }
}
